module.exports = {
  fallback: 'Resolva o desafio captcha.',
};
